var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "space-y-4" },
    [
      _vm._l(_vm.notificationArray, function (notification) {
        return [
          _c("notification-info", [
            _c(
              "div",
              { staticClass: "flex items-start justify-between w-full" },
              [
                _c("p", [
                  _vm._v(
                    "\n                        Your " +
                      _vm._s(notification.data.event) +
                      " event was rescheduled from " +
                      _vm._s(notification.data.old_event_date) +
                      "\n                        to " +
                      _vm._s(notification.data.new_event_date) +
                      "\n                    "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "-mx-1.5 -my-1.5 pl-3" }, [
                  _c(
                    "button",
                    {
                      staticClass:
                        "inline-flex rounded-md p-1.5 focus:outline-none",
                      on: {
                        click: function ($event) {
                          return _vm.dismiss(notification.id)
                        },
                      },
                    },
                    [
                      _c(
                        "svg",
                        {
                          staticClass: "h-5 w-5",
                          attrs: {
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 20 20",
                            fill: "currentColor",
                            "aria-hidden": "true",
                          },
                        },
                        [
                          _c("path", {
                            attrs: {
                              "fill-rule": "evenodd",
                              d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
                              "clip-rule": "evenodd",
                            },
                          }),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]
            ),
          ]),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }